import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import ProjectCard from '../components/ProjectCard';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ProjectCard title="Illustration Hunt" link="https://illustrationhunt.com" background="linear-gradient(to right,#D4145A 0%,#FBB03B 100%)" mdxType="ProjectCard">
One place to look for sites offering free illustrations.
    </ProjectCard>
    <ProjectCard title="JS13K Games" link="https://js13kgames.com/entries/connect" background="linear-gradient(to right, #3494e6, #ec6ead)" mdxType="ProjectCard">
Built a game under 13kb for js13kgames event with one of my friend Avikki
    </ProjectCard>
    <ProjectCard title="HTML Prank" link="https://chrome.google.com/webstore/detail/html-prank/bocemdfoolahglpjdaimkmcmdpedlgdl" background="linear-gradient(to right, #a770ef, #cf8bf3, #fdb99b)" mdxType="ProjectCard">
A chrome extension using which you can change any text present in the website.
    </ProjectCard>
    <ProjectCard title="Pokemon Cart" link="https://gilly-pokecart.surge.sh/" background="linear-gradient(to right,#76b852 0%,#8DC26F 100%)" mdxType="ProjectCard">
A single page pokemon shopping cart.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      